"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Details = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _components = require("../../components");
var _contexts = require("../../contexts");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Details = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    onCloseDetails
  } = (0, _contexts.useOlapicDetails)();
  const {
    activeMedia: clickedItem,
    mediaItems: detailItems
  } = (0, _contexts.useOlapicData)();
  const theme = (0, _mui.useTheme)();
  const isBreakpointLarge = (0, _mui.useMediaQuery)(theme.breakpoints.up('lg'));
  const clickedPosition = (0, _react.useMemo)(() => detailItems.findIndex(item => item.id === clickedItem), [detailItems, clickedItem]);
  const [currentPosition, setCurrentPosition] = (0, _react.useState)(clickedPosition);
  const detailItem = detailItems[currentPosition];

  // istanbul ignore next @preserve --not testable in jest environment, as it crashes the test
  const slide = (0, _react.useCallback)(direction => {
    if (direction === 'left') {
      const newPosition = currentPosition - 1;
      setCurrentPosition(newPosition >= 0 ? newPosition : 0);
    } else {
      const newPosition = currentPosition + 1;
      setCurrentPosition(newPosition <= detailItems.length - 1 ? newPosition : detailItems.length - 1);
    }
  }, [currentPosition, detailItems.length]);
  // istanbul ignore next @preserve --not testable in jest environment, as it crashes the test
  (0, _presentationHooks.useListenToKeyDown)(['ArrowLeft'], () => {
    slide('left');
  });

  // istanbul ignore next @preserve --not testable in jest environment, as it crashes the test
  (0, _presentationHooks.useListenToKeyDown)(['ArrowRight'], () => {
    slide('right');
  });
  (0, _presentationHooks.useListenToKeyDown)(['Escape'], () => {
    onCloseDetails();
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DetailsRoot, {
    "data-testid": getTestId(_constants.DETAILS),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Backdrop, {
      open: true,
      component: "div",
      onClick: onCloseDetails
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.DetailsContainer, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CloseButton, {
        size: "medium",
        variant: "text",
        color: "default",
        "data-testid": getTestId(_constants.DETAILS_CLOSE_BUTTON),
        onClick: onCloseDetails,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Clear, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ItemHolder, {
        children: detailItem ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.DetailItem, {
          detailItem: detailItem,
          currentPosition: currentPosition,
          numberOfSlides: detailItems.length,
          slide: slide
        }) : null
      }), isBreakpointLarge ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.OlapicSliderButtons, {
          slide: slide,
          origin: "details",
          activeItem: currentPosition,
          maxSlideRange: detailItems.length - 1
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Counter, {
          "data-testid": getTestId(_constants.DETAILS_COUNTER),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
            variant: "subtitle1",
            align: "center",
            component: "p",
            fontWeight: "bold",
            color: "white",
            children: [currentPosition + 1, "/", detailItems.length]
          })
        })]
      }) : null]
    })]
  });
};
exports.Details = Details;
var _default = exports.default = Details;
